var exports = {
  "kL": "x52a3aa3b--3ed754--container",
  "pU": "x52a3aa3b--3ed754--iframe",
  "VN": "x52a3aa3b--3ed754--close",
  "u1": "x52a3aa3b--3ed754--spinner",
  "$E": "x52a3aa3b--3ed754--container--fullscreen",
};

module.exports = exports;
